'use client';

import { useState, useCallback, useMemo } from 'react';
import { Item, useTableDraggableProps } from './types';

export const useTableDraggable = ({
  initialData,
  defaultList,
  disableLastCheckedItem = false,
  withCheckbox = true,
  translatedText = {
    heading: '',
    subheading: ''
  },
  tableClasses = {
    headercell: 'header-cell',
    tooltip: 'header-cell-tooltip',
    tooltipicon: 'tooltip-icon',
    leftcell: 'left-cell'
  }
}: useTableDraggableProps) => {
  const [listData, setListData] = useState(initialData);

  const onDraggableUpdate = useCallback(
    (data: Item[]) => {
      setListData(data);
    },
    [listData]
  );

  const updateCheckedInput = useCallback(
    (item: Item) => {
      setListData((prevData) => {
        //handle toggle checkbox value
        const updatedList = prevData.map((listItem) =>
          listItem.key === item.key
            ? { ...listItem, checked: !listItem.checked }
            : listItem
        );

        //if disableLastCheckedItem is true then handle disable last checkded checkbox
        if (disableLastCheckedItem) {
          const checkedCount = updatedList.filter(
            (listItem) => listItem.checked
          ).length;
          if (checkedCount === 1) {
            return updatedList.map((listItem) =>
              listItem.checked
                ? { ...listItem, disabled: true }
                : { ...listItem, disabled: false }
            );
          }
        }

        //return updated list
        return updatedList.map((listItem) => ({
          ...listItem,
          disabled: false
        }));
      });
    },
    [listData, disableLastCheckedItem]
  );

  const resetToinitialState = () => {
    setListData(initialData);
  };

  const resetToDefault = () => {
    setListData(defaultList as Item[]);
  };

  const tableDraggableProps = useMemo(
    () => ({
      listData,
      onDraggableUpdate,
      updateCheckedInput,
      withCheckbox,
      tableClasses,
      translatedText
    }),
    [
      listData,
      onDraggableUpdate,
      updateCheckedInput,
      withCheckbox,
      tableClasses,
      translatedText
    ]
  );

  return {
    listData,
    resetToinitialState,
    resetToDefault,
    tableDraggableProps
  };
};
